/* eslint-disable no-unused-expressions */
import * as carto from '@carto/carto-vl'
import mapboxgl from 'mapbox-gl'
import geojsonExtent from '@mapbox/geojson-extent'
// import store from '../store'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
function formatUrl (url) {
  return url.match(/^https?:\/\//) !== null ? url : 'http://' + url
}
export default class FoodMap {
  constructor (lang, messages) {
    this.lang = lang
    this.messages = messages
    this.loaded = false
    this.bridge = null
    this.bridge2 = null
    this.commercialLayer = null
    this.districtLimits = null
    this.communityLayer = null
    this.centroidsLayer = null
    this.newViz = null
    this.newSource = null
    this.geocoder = null
    this.categories = []
    this.vizFilter = ``
    this.bounds = [
      [-74.3138098, 45.1219833], // Southwest coordinates
      [-72.8453385, 45.8796636] // Northeast coordinates
    ]
    this.map = new mapboxgl.Map({
      container: 'map',
      style: carto.basemaps.voyager,
      center: { lng: -73.6839076, lat: 45.5485176 },
      // bearing: -38,
      zoom: 10.4,
      scrollZoom: true,
      minZoom: 9.5,
      maxBounds: this.bounds
    })
    // Add a geocoder and custom position
    this.geocoder = new MapboxGeocoder({
      accessToken: 'pk.eyJ1IjoiYWF1bmlvNzQiLCJhIjoiY2p6azduYXh1MGkwODNtazZsZHVqYmxvcCJ9.DGG6M0TVsjWe3cZJFvLoOQ',
      mapboxgl: mapboxgl,
      placeholder: this.messages.searchlocation
    })
    // Declaring the element to position in
    document.getElementById('geocoder').appendChild(this.geocoder.onAdd(this.map))

    this.nav = new mapboxgl.NavigationControl({
      showCompass: false
    })

    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: true,
      anchor: 'bottom'
      // offset: [linearOffset, -linearOffset]
    })
    this.tooltip = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: true,
      anchor: 'bottom'
      // offset: [linearOffset, -linearOffset]
    })

    this.map.addControl(this.nav, 'top-right')
  }

  /**
 * Initialize and add to then map a new layer
 *  @param {string} layerID the name you want to give to the layer
 *  @param {string} source the source, could be an url, a carto dataset or am sql string
 *  @param {string} viz the viz associated to the source
 */
  initCartoLayer = (layerID, source, viz) => {
    this.newSource = new carto.source.GeoJSON(source)
    const cartoViz = new carto.Viz(viz)
    // TODO Factorize the code below
    // const layer = new carto.Layer(layerID, this.newSource, this.newViz)
    // layer.addTo(this.map, 'watername_ocean')
    if (layerID === 'commercial') {
      this.commercialLayer = new carto.Layer(layerID, this.newSource, cartoViz)
      this.commercialLayer.addTo(this.map, 'watername_ocean')
    } else if (layerID === 'district') {
      this.districtLimits = new carto.Layer(layerID, this.newSource, cartoViz)
      this.districtLimits.addTo(this.map, 'watername_ocean')
    } else if (layerID === 'community') {
      this.communityLayer = new carto.Layer(layerID, this.newSource, cartoViz)
      this.communityLayer.addTo(this.map, 'roadname_pri')
    } else if (layerID === 'districtCentroids') {
      this.centroidsLayer = new carto.Layer(layerID, this.newSource, cartoViz)
      // SET CENTROIDS POINTS LABELING
      this.centroidsLayer.on('loaded', () => {
        this.map.addSource('labels', { type: 'geojson', data: null })
        const labelSource = this.map.getSource('labels')
        const features = cartoViz.variables.v_features.value
        const geojsonFeatures = features.map(feature => {
          return {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': feature.getRenderedCentroid()
            },
            'properties': {
              'label_field': `${feature.properties['qty']}`
            }
          }
        })
        labelSource.setData({
          type: 'FeatureCollection',
          features: geojsonFeatures
        })
        // Style labels
        this.map.addLayer({
          'id': 'my-labels',
          'type': 'symbol',
          'source': 'labels',
          'layout': {
            'text-field': '{label_field}',
            'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
            'text-size': 12,
            'text-max-width': 12,
            'text-justify': 'center'
          },
          'paint': {
            'text-color': 'black'
          }
        })
      })
      this.centroidsLayer.addTo(this.map, 'watername_ocean')

      this.centroidsLayer.on('updated', () => {
        if (this.map.getZoom() < 12.25) {
          if (!this.map.getLayer('my-labels')) {
            this.map.addLayer({
              'id': 'my-labels',
              'type': 'symbol',
              'source': 'labels',
              'layout': {
                'text-field': '{label_field}',
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                'text-size': 12,
                'text-max-width': 12,
                'text-justify': 'center'
              },
              'paint': {
                'text-color': 'black'
              }
            })
          }
        } else {
          if (this.map.getLayer('my-labels')) {
            this.map.removeLayer('my-labels')
          }
        }
        if (this.map.getZoom() < 13.25) {
          document.querySelector('.commercialDataTab').style.display = 'none'
        } else {
          document.querySelector('.commercialDataTab').style.display = 'block'
        }
      })
    }
  }

  async layerPopup (lyr) {
    let layer = ``
    var getColor = (cat) => {
      if (cat === 'Services et organismes communautaire en sécurité alimentaire') {
        return 'error'
      } else if (cat === 'Production agricole urbaine' || cat === 'Production agricole') {
        return 'success'
      } else if (cat === 'Points de distributions de proximité d’aliments frais') {
        return 'primary'
      } else if (cat === 'white') {
        return 'whiteText'
      } else {
        return 'secondary'
      }
    }
    var interactivity
    if (lyr === 'community') {
      layer = await this.communityLayer
      interactivity = new carto.Interactivity(layer)
    } else if (lyr === 'commercial') {
      layer = await this.commercialLayer
      interactivity = new carto.Interactivity(layer)
    } else if (lyr === 'districtCentroids') {
      layer = await this.centroidsLayer
      var clusterInteractivity = new carto.Interactivity(layer)
    }

    if (lyr === 'districtCentroids') {
      clusterInteractivity.on('featureClick', event => {
        if (event.features.length) {
          const coords = event.coordinates
          this.map.flyTo({ center: [coords.lng, coords.lat], zoom: 13 })
        }
      })
    } else {
      // Click
      interactivity.on('featureClick', event => {
        if (event.features.length) {
          const feature = event.features[0]
          const coords = event.coordinates
          const name = feature.variables.name.value ? `<div class="as-title as-font--medium whiteText">${feature.variables.name.value}</div>` : ``
          const typeen = feature.variables.typeen.value ? `<div class="label"><i class="${this.getIcon(feature.variables.sscatfr.value)}"></i><div class="values"> ${feature.variables.typeen.value}</div></div>` : ``
          const typefr = feature.variables.typefr.value ? `<div class="label"><i class="${this.getIcon(feature.variables.sscatfr.value)}"></i><div class="values">${feature.variables.typefr.value}</div></div>` : ``
          const address = feature.variables.address.value ? `<div class="label"> <i class="fas fa-map-marked-alt"></i>  <div class="values"> ${feature.variables.address.value.split(',').join('<br>')}</div></div>` : ``
          const phone = feature.variables.phone.value ? `<div class="label"><i class="fas fa-phone-alt"></i>  <div class="values"> <a href="tel:${feature.variables.phone.value}">${feature.variables.phone.value}</a></div></div>` : ``
          const heures = feature.variables.heures.value ? `<div class="label"><i class="fas fa-door-open"></i>  <div class="values"> ${feature.variables.heures.value.split(',').join('<br>')}</div></div>` : ``
          const hours = feature.variables.hours.value ? `<div class="label"><i class="fas fa-door-open"></i>  <div class="values"> ${feature.variables.hours.value.split(',').join('<br>')}</div></div>` : ``
          const web = feature.variables.web.value ? `<div class="label"><i class="fas fa-desktop"></i>  <div class="values"> <a style="word-break=break-word" href="${formatUrl(feature.variables.web.value)}" target="_blank">${this.messages.visitWeb}</a></div></div>` : ``
          const cat = feature.variables.catfr.value
          const mailto = `mailto:general@justicealimentairemtl.org?Subject=new comment on ${feature.variables.name.value}, ${feature.variables.address.value}`
          const html = `

          <div class="as-p--12 as-mb--12 as-subheader as-bg--ui-01">
            <div class="as-p--12 as-mb--12 as-subheader ${getColor(cat)}">
              ${name}
            </div>
            <div class="as-p--12 as-mb--12 as-subheader as-bg--ui-01" style='text-align:left'>
              ${this.lang === 'fr' ? typefr : typeen}
              ${phone}
              ${this.lang === 'fr' ? heures : hours}
              ${web}
              ${address}
              <div class="label"><i class="fas fa-envelope"></i><div class="values"><a href="${mailto}" >&nbsp;${this.messages.suggest}</a></div></div>
            </div>
          </div>
            `
          this.popup.setLngLat([coords.lng, coords.lat])
          this.popup.setHTML(html)
          this.map.flyTo({ center: event.coordinates, offset: [0, 300, 0, 0] }).then(this.popup.addTo(this.map))
        }
      })
      // featureEnter
      interactivity.on('featureHover', event => {
        if (event.features.length) {
          const feature = event.features[0]
          const coords = event.coordinates
          const name = feature.variables.name.value
          const cat = feature.variables.catfr.value
          const html = `<span role="tooltip" class="as-display as-tooltip as-tooltip--top as-tooltip--${getColor(cat)} ${getColor('white')}">${name}</span>`
          this.tooltip.setLngLat([coords.lng, coords.lat])
          this.tooltip.setHTML(html)
          this.tooltip.addTo(this.map)
        }
      })
      // featureLeave
      interactivity.on('featureLeave', event => {
        if (event.features.length > 0) {
          this.tooltip.remove()
        }
      })
    }
  }

  getIcon (type) {
    if (type === 'Dépannage alimentaire et aide alimentaire') {
      return 'fas fa-heart'
    } else if (type === 'Éducation populaire en sécurité alimentaire') {
      return 'fas fa-people-carry'
    } else if (type === 'Jardins') {
      return 'fas fa-seedling'
    } else if (type === 'Marchés fermiers') {
      return 'fas fa-tractor'
    } else if (type === 'Points de chute aliments frais') {
      return 'fas fa-people-carry'
    } else if (type === 'Restaurants') {
      return 'fas fa-utensils'
    } else if (type === 'Supermarkets') {
      return 'fas fa-apple-alt'
    } else if (type === 'Dépanneurs et épiceries') {
      return 'fas fa-store'
    } else if (type === 'Magasin à rayons') {
      return 'fas fa-warehouse'
    } else if (type === 'Restaurant rapide et mêts pour emporter') {
      return 'fas fa-hamburger'
    } else if (type === 'Aliments naturels') {
      return 'fas fa-plus-square'
    } else if (type === 'Magasins d’aliments spécialisés') {
      return 'fas fa-bread'
    } else if (type === 'Services Traiteurs') {
      return 'fas fa-car'
    } else if (type === 'Saisonnier') {
      return 'fas fa-ice-cream'
    } else {
      return 'far fa-sticky-note'
    }
  }

  filterViz (filters) {
    // The whitespace before filter  is important !
    var filtered = "'" + filters.join("','") + "'"
    if (filters) {
      // Filtering mecanism for community data
      const vizDefinition = `
      @name: $name
      @caten: $categoryen
      @catfr: $categoryfr
      @sscaten: $subcategoryen
      @sscatfr: $subcategoryfr
      @typefr: $typefr
      @typeen: $typeen
      @address: $address
      @district: $district
      @phone: $téléphone
      @heures: $heuresdouverture
      @hours: $openinghours
      @web: $web
      @path: $categoryPath
      symbol: ramp(buckets(@sscatfr,
      ['Dépannage alimentaire et aide alimentaire',
       'Éducation populaire en sécurité alimentaire',
       'Jardins',
       'Marchés fermiers',
       'Points de chute aliments frais'
       ]),
      [
        image('/icons/svgs/solid/heart-rw4.svg'),
        image('/icons/svgs/solid/people-carry-rw5.svg'),
        image('/icons/svgs/solid/seedling-rw4.svg'),
        image('/icons/svgs/solid/tractor-rw4.svg'),
        image('/icons/svgs/solid/truck-loading-rw4.svg'),
      ]
      )
      symbolPlacement: placement(0,-0.10)
      width: zoom()*1.5
      filter: @path in [${filtered}] and ramp(zoomrange([12.5,13]),[false,true])
      `
      this.communityLayer.blendToViz(new carto.Viz(vizDefinition), 500)
    }
  }
  filterCommercialViz (filters) {
    const filtered = "'" + filters.join("','") + "'"
    const vizDefinition = `
      @name: $name
      @caten: $categoryen
      @catfr: $categoryfr
      @sscaten: $subcategoryen
      @sscatfr: $subcategoryfr
      @typefr: $typefr
      @typeen: $typeen
      @address: $address
      @district: $district
      @phone: $téléphone
      @heures: $heuresdouverture
      @hours: $heuresdouverture
      @web: $web
      @path: $categoryPath
      width: zoom()/2.5
      strokeWidth: 0.25
      color: #F9BE02
      filter: @path in [${filtered}] and ramp(zoomrange([13.25,13.25]),[false,true])
    `
    // console.log(vizDefinition)
    this.commercialLayer.blendToViz(new carto.Viz(vizDefinition), 500)
  }
  setMapCenter (data, properties, id) {
    if (!id) { } else {
      let filteredData = data.features.filter(function (i) {
        return i.properties[properties] === id.toString()
      })
      // Creating a new geojson to filter on
      let newGeoj = {}
      newGeoj['name'] = 'LIMADMIN'
      newGeoj['type'] = 'FeatureCollection'
      newGeoj['features'] = filteredData
      const bbox = geojsonExtent(newGeoj)
      this.map.fitBounds(bbox, {
        padding: { top: 10, bottom: 10, left: 10, right: 10 }
      })
    }
  }
}
